<template>
  <div>
    <QDialog
      v-model="innerValue"
      :backdrop-filter="props.backdropFilter"
    >
      <div
        class="tw-relative tw-aspect-video tw-overflow-hidden"
        :class="[props.videoWidth, props.containerClass]"
        :style="props.containerStyle"
      >
        <QBtn
          flat
          round
          dense
          icon="close"
          :class="props.closeButtonClass"
          @click="innerValue = false"
        />
        <MediaYoutubeAutoPlay
          :id="`video-${videoId}`"
          :url="props.youtubeUrl"
          width="tw-w-full"
          height="tw-h-full"
          :custom-video-player="customVideoPlayer"
          immediate
        />
      </div>
    </QDialog>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  youtubeUrl: {
    type: String,
    default: "",
  },
  backdropFilter: {
    type: String as PropType<
      | "blur(4px)"
      | "blur(4px) saturate(150%)"
      | "brightness(60%)"
      | "invert(70%)"
      | "grayscale(100%)"
      | "contrast(40%)"
      | "hue-rotate(120deg)"
      | "sepia(90%)"
      | "saturate(80%)"
      | "none"
    >,
    default: "brightness(40%)",
  },
  videoWidth: {
    type: String,
    default: "tw-w-[90vw] md:tw-w-[80vw] lg:tw-w-[60vw] tw-max-w-[900px]",
  },
  videoHeight: {
    type: String,
    default: "",
  },
  containerStyle: {
    type: Object,
    default: () => ({}),
  },
  containerClass: {
    type: String,
    default: "",
  },
  closeButtonClass: {
    type: String,
    default: "tw-absolute tw-top-2 tw-right-2 tw-z-30 tw-bg-black/60 tw-text-white",
  },
  customVideoPlayer: {
    type: String,
    default: "",
  },
});

const innerValue = defineModel<boolean>({ default: false });

const { getYoutubeIdFromUrl } = useYoutube();
const videoId = computed(() => getYoutubeIdFromUrl(props.youtubeUrl));
</script>
